import { render, staticRenderFns } from "./ConsolidadosPage.vue?vue&type=template&id=4ed7cc3c&"
import script from "./ConsolidadosPage.vue?vue&type=script&lang=js&"
export * from "./ConsolidadosPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports